import 'normalize.css';
import '@brighterionai/br-ui/dist/theme/theme.css';
import '@brighterionai/br-ui/dist/index.css';
import './index.css';
import './polyfill';
import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './i18n';
import './services/axiosService';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
    <StrictMode>
        <App />
    </StrictMode>
);
